// O backend às vezes devolve a mensagem de erro com o cabeçalho técnico do
// procedure SQL na frente (ex.: "Procedure: [ofv3_Chip].[SupplierInsert]\r\nErro: ...").
// Remove esse trecho antes de mostrar a mensagem pro usuário.
function stripProcedurePrefix(message) {
  if (!message) {
    return message;
  }
  return message.replace(/^\s*Procedure:\s*\[[^\]]+\]\.\[[^\]]+\]\s*[\r\n]+/i, "").trim();
}

// Backend de validação de campos retorna um array "validations": [{ field, message }].
// Junta todas as mensagens numa string só, uma por linha, pra exibir no toast.
function formatValidationErrors(validations) {
  if (!Array.isArray(validations) || validations.length === 0) {
    return null;
  }
  return validations.map((item) => item.message).filter(Boolean).join("\n");
}

function handleResponse(response, area) {
  if (response.status === 204) {
    catchError(response, area, true);
    return null;
  }

  if (response.status === 409) {
    catchError(response, area);
    return {
      error: true,
      status: 409,
      message: response.data?.error || "Conflito detectado (409)",
    };
  }

  if (response.status !== 200 && response.status !== 201 && response.status !== 202) {
    catchError(response.response, area);
    return {
      error: true,
      status: response.response?.status,
      friendlyMessage: response.response?.data?.friendlyMessage,
      message: response.response?.data?.message,
      raw: response.response?.data,
    };
  }

  if (response.data)
    return response.data.result ? response.data.result : response.data;

  return response.result;
}

function catchError(error, area, warning) {
  try {
    let message = "Error: " + (error?.status ? error?.status : error?.code);
    message += " | Local: " + area;
    message +=
      " | Status: " +
      (error?.statusText ? error?.statusText : error?.response?.status);
    if (error?.response?.data) {
      if (error?.response?.data.error) {
        message += " | Messages: " + error.response.data.error;
      }
    }
    if (!warning) {
      console.log(message);
    } else {
      console.warn(message);
    }
  } catch (ex) {
    console.log(ex);
  }
}

export const errorHandling = {
  handleResponse,
  cathError: catchError,
  stripProcedurePrefix,
  formatValidationErrors,
};
